"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Availability = void 0;
var driftTypes_1 = require("@driftt/app-config/dist/utils/driftTypes");
Object.defineProperty(exports, "Availability", {
  enumerable: true,
  get: function get() {
    return driftTypes_1.AvailabilityIF;
  }
});